
<div class="row">
    <div class="col-md-12 col-lg-9">
        <div class="card">
            <div class="card-body">
                <h4 class="card-title">Client details</h4>
                <form autocomplete="off" #createClientForm="ngForm">
                    <div class="form-group">
                        <label for="clientId">Client Id</label>
                        <input type="text" class="form-control" #clientId="ngModel" [(ngModel)]="createClient.clientId" required
                            name="clientId">
                        <div *ngIf="!clientId.valid && clientId.touched" class="alert alert-danger">
                            Field is required
                        </div>
                    </div>
                
                    <div class="form-group">
                        <label for="clientName">Client Name</label>
                        <input type="text" class="form-control" #clientName="ngModel" [(ngModel)]="createClient.clientName" required
                            name="clientName">
                        <div *ngIf="!clientName.valid && clientName.touched" class="alert alert-danger">
                            Field is required
                        </div>
                    </div>

                    <div class="form-group">
                        <label for="siteInfoCompanyId">SiteInfo Company Id</label>
                        <input type="text" class="form-control" #siteInfoCompanyId="ngModel" [(ngModel)]="createClient.siteInfoCompanyId" required
                            name="siteInfoCompanyId">
                        <div *ngIf="!siteInfoCompanyId.valid && siteInfoCompanyId.touched" class="alert alert-danger">
                            Field is required
                        </div>
                    </div>                    
                
                    <div class="form-group">
                        <label for="secret">Secret</label>
                        <input type="text" class="form-control" #secret="ngModel" [(ngModel)]="createClient.secret" required
                            name="secret">
                        <div *ngIf="!secret.valid && secret.touched" class="alert alert-danger">
                            Field is required
                        </div>
                    </div>     

                    <div class="form-group">
                        <label>SiteInfo Api Url</label><br>
                        <label>{{createClient.siteInfoApiBaseUrl}}</label>
                    </div>     

                    <button class="btn btn-primary btn-lg" [disabled]="!createClientForm.valid" (click)="create()">Create</button>
                </form>       
            </div>
        </div>
    </div>
</div>
